<div class="content-card">
  <form [formGroup]="searchForm" class="py-12">
    <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="10px" fxLayoutGap.lt-md="0">
      <mat-form-field fxFlex="100%">
        <input formControlName="name" matInput placeholder="Denominazione">
      </mat-form-field>
      <mat-form-field fxFlex="calc(50% - 20)">
        <mat-label>Tipo</mat-label>
        <mat-select formControlName="types">
          <mat-option *ngFor="let tipo of tipi" [value]="tipo">{{tipo}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field fxFlex="calc(50% - 20)">
        <mat-label>Sottotipologia</mat-label>
        <mat-select formControlName="subtypes">
          <mat-option *ngFor="let sottotipo of sottotipi" [value]="sottotipo">{{sottotipo}}</mat-option>
        </mat-select>
      </mat-form-field>
      <div class="d-flex justify-content-center align-items-center">
        <div>
          <button [matTooltip]="'Cerca'" mat-raised-button (click)="search()" class="mt-4 mx-4"  aria-label="Cerca">
            <mat-icon class="mat-24">search</mat-icon>
          </button>
          <button [matTooltip]="'Resetta i campi'" mat-raised-button (click)="clear()" class="mt-4 mx-4"  aria-label="Reset">
            <mat-icon class="mat-24">clear</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </form>

  <div class="mat-elevation-z8 mt-20">
    <mat-table #table [dataSource]="dataSource" class="table-condensed" matSort>
      <ng-container matColumnDef="id">
        <mat-header-cell fxFlex *matHeaderCellDef mat-sort-header>ID</mat-header-cell>
        <mat-cell fxFlex *matCellDef="let row">{{row.id}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="name">
        <mat-header-cell fxFlex *matHeaderCellDef mat-sort-header>Denominazione</mat-header-cell>
        <mat-cell fxFlex *matCellDef="let row">{{row.name}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="types">
        <mat-header-cell fxFlex *matHeaderCellDef mat-sort-header>Tipo</mat-header-cell>
        <mat-cell fxFlex *matCellDef="let row">{{row.types}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="subtypes">
        <mat-header-cell fxFlex *matHeaderCellDef mat-sort-header>Sottotipologia</mat-header-cell>
        <mat-cell fxFlex *matCellDef="let row">{{row.subtypes}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="coordinates">
        <mat-header-cell fxFlex *matHeaderCellDef mat-sort-header>Coordinate</mat-header-cell>
        <mat-cell fxFlex *matCellDef="let row">{{row.coordinates}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="dettagli">
        <mat-header-cell fxFlex="80px" *matHeaderCellDef>Dettagli</mat-header-cell>
        <mat-cell fxFlex="80px" fxLayoutGap="4px" *matCellDef="let row">
          <button mat-raised-button (click)="edit(row)" color="primary"  aria-label="Seleziona">
            <mat-icon>edit</mat-icon>
          </button>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *cdkRowDef="let row; columns: displayedColumns;"></mat-row>

    </mat-table>
    <div class="empty-table" *ngIf="dataSource.data.length===0">
      Nessun elemento presente. Per iniziare compila il form di ricerca
    </div>

    <mat-paginator [pageSizeOptions]="[25, 50, 100]"> </mat-paginator>
  </div>
</div>

<div class="new-item">
  <button mat-fab color="primary" aria-label="Inserisci nuova Richiesta" (click)="new()">
    <mat-icon>add</mat-icon>
  </button>
</div>

<ng-template #detailsModal let-data>
  <mat-dialog-content class="mat-typography">
    <h2 *ngIf="editItem && !editItem.id" mat-dialog-title>Inserisci Nuovo marker</h2>
    <h2 *ngIf="editItem && editItem.id" mat-dialog-title>Modifica marker: {{editItem.marker_NAME}}</h2>
    <br><br>
    <form [formGroup]="editItemForm">
      <div fxLayout="row wrap" fxLayoutGap="12px 50px">
        <mat-form-field class="mb-3" fxFlex="calc(100% - 12px)">
          <input formControlName="name" matInput placeholder="Nome marker" required>
        </mat-form-field>
        <mat-form-field class="mb-3" fxFlex="calc(100% - 12px)">
          <input formControlName="types" matInput placeholder="Tipo" required>
        </mat-form-field>
        <mat-form-field class="mb-3" fxFlex="calc(100% - 12px)">
          <input formControlName="subtypes" matInput placeholder="Sottotipo" required>
        </mat-form-field>
        <mat-form-field class="mb-5" fxFlex="calc(100% - 12px)">
          <mat-hint><strong class="fs-6">Inserire latitudine e longitudine separati da una virgola o lasciare il campo vuoto per rieseguire il GeoCoding</strong></mat-hint>
          <input formControlName="coordinates" matInput placeholder="Coordinate">
        </mat-form-field>
        <br />
      <mat-form-field class="mb-3" fxFlex="calc(33% - 12px)">
        <input formControlName="indirizzo" matInput placeholder="Indirizzo">
      </mat-form-field>
      <mat-form-field class="mb-3" fxFlex="calc(33% - 12px)">
        <input formControlName="cap" matInput placeholder="CAP">
      </mat-form-field>
      <mat-form-field class="mb-3" fxFlex="calc(33% - 12px)">
        <input formControlName="municipio" matInput placeholder="Municipio">
      </mat-form-field>
      <mat-form-field class="mb-3" fxFlex="calc(33% - 12px)">
        <input formControlName="località" matInput placeholder="Località">
      </mat-form-field>
      <mat-form-field class="mb-3" fxFlex="calc(33% - 12px)">
        <input formControlName="distretto" matInput placeholder="Distretto">
      </mat-form-field>
      <mat-form-field class="mb-3" fxFlex="calc(33% - 12px)">
        <input formControlName="comune" matInput placeholder="Comune">
      </mat-form-field>
      <mat-form-field class="mb-3" fxFlex="calc(33% - 12px)">
        <input formControlName="provincia" matInput placeholder="Provincia">
      </mat-form-field>
      <mat-form-field class="mb-3" fxFlex="calc(33% - 12px)">
        <input formControlName="telefono" matInput placeholder="Telefono">
      </mat-form-field>
      <mat-form-field class="mb-3" fxFlex="calc(33% - 12px)">
        <input formControlName="email" matInput placeholder="Email">
      </mat-form-field>
      <mat-form-field class="mb-3" fxFlex="calc(33% - 12px)">
        <input formControlName="partitaIVA" matInput placeholder="Partita IVA">
      </mat-form-field>
      <mat-form-field class="mb-3" fxFlex="calc(33% - 12px)">
        <input formControlName="capacitàRicettiva" matInput placeholder="Capacità Ricettiva">
      </mat-form-field>
      <mat-form-field class="mb-3" fxFlex="calc(33% - 12px)">
        <input formControlName="classeUtenza" matInput placeholder="Classe Utenza">
      </mat-form-field>
      <mat-form-field class="mb-3" fxFlex="calc(33% - 12px)">
        <input formControlName="numeroAccreditamento" matInput placeholder="Numero Accreditamento">
      </mat-form-field>
      <mat-form-field class="mb-3" fxFlex="calc(33% - 12px)">
        <input formControlName="scadenzaAccreditamento" matInput placeholder="Scadenza Accreditamento">
      </mat-form-field>
      <mat-form-field class="mb-3" fxFlex="calc(100% - 12px)">
        <input formControlName="indirizzoCompleto" matInput placeholder="Indirizzo Completo">
      </mat-form-field>
      <mat-form-field class="mb-3" fxFlex="calc(100% - 12px)">
        <input formControlName="googleMaps" matInput placeholder="Google Maps">
      </mat-form-field>
      <mat-checkbox formControlName="attivo" class="mb-3" fxFlex="calc(100% - 12px)">Attivo</mat-checkbox>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-raised-button (click)="save()">Salva</button>
    <button mat-raised-button (click)="delete()">Elimina</button>
    <button mat-raised-button mat-dialog-close>Chiudi</button>
  </mat-dialog-actions>
</ng-template>
